module.exports = __webpack_public_path__ + "static/options_vueminder-774760b519672a6063ddb6f302372389.png";